import React from "react";
import { HiOutlineArrowRightOnRectangle } from "react-icons/hi2";
import { roundedPanel } from "./designTokens";

export function MobileMenuUser({ user, handleLogout, onClose, t }) {
  if (!user) return null;

  return (
    <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/10 bg-slate-900">
      <div
        className={`flex items-center gap-3 p-3 ${roundedPanel} bg-white/10 mb-2 border border-white/10`}
      >
        <div className="w-10 h-10 rounded-lg bg-white/20 text-white flex items-center justify-center text-sm font-bold shrink-0">
          {user.first_name?.charAt(0).toUpperCase() ||
            user.username?.charAt(0).toUpperCase()}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold truncate text-white">
            {user.first_name || user.username}
          </p>
          <p className="text-xs truncate text-white/80">{user.email}</p>
        </div>
      </div>
      <button
        onClick={() => {
          handleLogout();
          onClose();
        }}
        className={`w-full flex items-center justify-center gap-2 px-4 py-2.5 ${roundedPanel} text-sm font-medium text-white bg-white/20 border border-white/20 hover:bg-white/30 transition-colors`}
      >
        <HiOutlineArrowRightOnRectangle className="w-4 h-4" />
        {t("logout") || "Déconnexion"}
      </button>
    </div>
  );
}
